import React, { useState } from 'react';
import { RatingStage } from './RatingStage/RatingStage.tsx';
import { FeedbackStage } from './FeedbackStage/FeedbackStage.tsx';
export function FeedbackFormDialog({ open, onClose, onSubmit, isLoggedIn }) {
    const [stage, setStage] = useState('rating');
    const [rating, setRating] = useState(0);
    const [feedbackText, setFeedbackText] = useState('');
    const [email, setEmail] = useState('');
    const resetForm = ()=>{
        setStage('rating');
        setRating(0);
        setFeedbackText('');
        setEmail('');
    };
    const handleSkip = ()=>{
        onSubmit({
            rate: rating > 0 ? rating : undefined,
            feedback: feedbackText || undefined,
            email: email || undefined,
            skipped: true
        });
        resetForm();
        onClose();
    };
    const handleStarSelect = (value)=>{
        setRating(value);
        setStage('feedback');
    };
    const handleSubmit = ()=>{
        onSubmit({
            rate: rating > 0 ? rating : undefined,
            feedback: feedbackText || undefined,
            email: email || undefined,
            skipped: false
        });
        resetForm();
        onClose();
    };
    if (stage == 'rating') {
        return /*#__PURE__*/ React.createElement(RatingStage, {
            open: open,
            onClose: handleSkip,
            rating: rating,
            onStarSelect: handleStarSelect
        });
    }
    return /*#__PURE__*/ React.createElement(FeedbackStage, {
        open: open,
        onSubmit: handleSubmit,
        rating: rating,
        onRatingChange: setRating,
        feedbackText: feedbackText,
        onFeedbackTextChange: setFeedbackText,
        email: email,
        onEmailChange: setEmail,
        isLoggedIn: isLoggedIn
    });
}
